import { createSlice } from '@reduxjs/toolkit'

const ITEM_LIMIT = 12

const initialState = {
  maxRange: 0,
  limit: ITEM_LIMIT,
  page: 1,
}

export const itemPaginateSlice = createSlice({
  name: 'itemPaginate',
  initialState,
  reducers: {
    hydrate: (state, action) => {
      return {
        ...state,
        maxRange: action.payload.maxRange,
        limit: action.payload.limit,
        page: action.payload.page,
      }
    },
    setPage: (state, action) => {
      return {
        ...state,
        page: action.payload
      }
    },
    setLimit: (state, action) => {
      return {
        ...state,
        limit: action.payload
      }
    },
    setMaxRange: (state, action) => {
      return {
        ...state,
        maxRange: action.payload
      }
    },
  }
})

export const { hydrate, setPage, setLimit, setMaxRange } = itemPaginateSlice.actions

export default itemPaginateSlice.reducer